<template><div>
    <nav class="navbar is-light" role="navigation" aria-label="main navigation">
        <div class="navbar-brand is-hoverable">
          <router-link to="/" class="navbar-item is-hoverable"><img src="/applogo.png" width="250" height="32"></router-link>
      
          <a role="button" @click="toggleMenu" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarMain">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
      
        <div id="navbarMain" class="navbar-menu" >
          <div class="navbar-end">
      
            <router-link class="navbar-item" to="/about">О сервисе</router-link>
            <router-link class="navbar-item" to="/catalog">Каталог</router-link>
            <router-link class="navbar-item" to="/prices">Тарифы</router-link>
            <router-link class="navbar-item" to="/dashboard">Кабинет</router-link>
            <router-link class="navbar-item" to="/project">Редактор</router-link>
      
            <div class="navbar-item has-dropdown is-hoverable" @click="toggleSubMenu" v-bind:class="{ 'is-active': isActive }">
              <router-link  class="navbar-link" to="/help" aria-expanded="false" data-target="navbarDropdown">Справка</router-link>
              <div id="navbarDropdown" class="navbar-dropdown is-boxed">
                    <a class="navbar-item">Контакты</a>
                    <hr class="navbar-divider">
                    <a class="navbar-item">Сообщить об ошибке</a>
              </div>
            </div>
          </div>
      
          <div class="navbar-end">
            <div class="navbar-item">
              <div class="buttons">
                <a class="button is-primary">Регистрация</a>
                <a class="button is-info">Вход</a>
              </div>
            </div>
          </div>
        </div>
      </nav></div>
</template>


<script>
export default {
    name:'navbar',
    props: {

    },

    data (){ return {
        app: 1,
        data: [],
        isActive: false
      }
    },
    computed: {
        
    },
    created () {
      document.addEventListener('click', this.hideMenus)
    },
    destroyed () {
      document.removeEventListener('click', this.hideMenus)
    },
    methods: {
        hideMenus(e){
            this.isActive = false;
            return this.isActive;
        },
        toggleSubMenu(e){
            this.isActive = !this.isActive;
            return this.isActive;
        },
        toggleMenu(e){
            console.log(e.target);
            //e.target.classList.toggle('is-active');
            const target = e.target.dataset.target;
            const $target = document.getElementById("navbarMain");
            e.target.classList.toggle('is-active');
            $target.classList.toggle('is-active');              

        }
    }
}
</script>




<style>

.button { border-radius: 2px}

.navbar{
    box-shadow: 0 1px 2px rgba(10, 10, 10, .1);
}

.navbar-item img {
    max-height: 4rem;
}
.navbar-dropdown {
 border-bottom-left-radius: 2px; 
 border-bottom-right-radius: 2px;
}

.navbar-divider { height: 1px;}

.navbar-brand>.navbar-item.is-active{background-color: transparent !important}
.navbar-brand>.navbar-item.is-active:hover{background:  #e8e8e8 !important}

</style>
